/* NOFACEBABY FX — see nfb-fx.css. Tags headings and photos, reveals them once
   as they scroll into view, drives the neon scroll line. No smooth scrolling. */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && Shopify.designMode;
  if (reduce || design || !('IntersectionObserver' in window)) return;
  html.classList.add('nfb-fx-on');

  var HEADINGS = [
    '.nfb-masonry__title', '.nfb-top-picks__title', '.nfb-drop-feed__title', '.nfb-showcase-title',
    '.nfb-collection-showcase__title', '.nfb-originality__title', '.nfb-instagram__title-bottom',
    '.nfb-newsletter__title', '.main-page-title', '.collection-hero__title', '.title-wrapper-with-link .title'
  ].join(',');
  var PHOTOS = [
    '.nfb-masonry__card img', '.nfb-instagram__mobile-item img', '.nfb-collection-showcase img',
    '.card__media img', '.nfb-originality img'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('fx-in');
      io.unobserve(el);
      // hand the element back to the section's own styles once the reveal is done
      el.addEventListener('animationend', function done() {
        el.classList.remove('fx-in', 'fx-scan', 'fx-flash');
        el.removeEventListener('animationend', done);
      });
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

  function tag(root) {
    (root || document).querySelectorAll(HEADINGS).forEach(function (el) {
      if (el.dataset.fx) return; el.dataset.fx = 1;
      el.classList.add('fx-scan'); io.observe(el);
    });
    (root || document).querySelectorAll(PHOTOS).forEach(function (el) {
      if (el.dataset.fx) return; el.dataset.fx = 1;
      // photos already on screen at load just show
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return;
      el.classList.add('fx-flash'); io.observe(el);
    });
  }

  function progress() {
    var bar = document.createElement('div');
    bar.className = 'fx-progress'; bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    var draw = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, window.scrollY / max) : 0) + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(draw); } }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  }

  function boot() { tag(); progress(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { tag(e.target); });
})();
